import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Viewer } from '@react-pdf-viewer/core';
import ReactQuill from 'react-quill';
import { Worker } from '@react-pdf-viewer/core';

//components
import applicationRouter from '~/hoc/applicationRouter'
import withRemoveDialog from '~/hoc/withRemoveDialog';
import withLocalization from '~/hoc/withLocalization';

//configs
import { getUploadedFileURL } from '~/library/config';

//styles
import '../../../../styles/css/styles.css';
import 'react-quill/dist/quill.snow.css';


//this component displays all the documents with checkbox// 
//and the ones in the current template are checked//

class DocumentReport extends Component {
    state = {
        template_id: null,
        documentList: [],
        template_name: null,
        client_data: null,
        hasId: false
    }

    componentDidMount() {
        let id = window.location.pathname.split('/')[2];
        if (!id) return;

        this.setState({ template_id: id, hasId: true }, () => {
            this.loadData();
        })
    }

    loadData = async () => {
        await this.props.documentStore.getDoumentsInTemplateByIdInSelectedOrder(this.state.template_id).then(
            (data) => {
                this.setState(
                    {
                        documentList: data.rows,
                        template_name: data.template.template_name,
                        client_data: data.client_data
                    })
            }
        )
    }

    loadPdf = (id) => {
        let pdf = getUploadedFileURL(id);
        return (
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js">
                <Viewer fileUrl={pdf} />
            </Worker>
        )
    }
    render() {
        if (!this.state.hasId) return <div>No id found</div>
        return (
            <div className="">
                <div style={{ pageBreakAfter: 'always', width: '100%', height: '100%', textAlign: 'center', padding: '30px' }}>
                    {this.state.client_data &&
                        <div>
                            <img style={{ maxHeight: '80px', maxWidth: '200px', marginTop: '30%' }}
                                src={getUploadedFileURL(this.state.client_data.image)}
                                alt='client logo'
                            />
                            <div>{this.state.client_data.name}</div>
                            <div>{this.state.client_data.tax_number}</div>
                            <div>{this.state.client_data.address}</div>
                        </div>
                    }
                    <div style={{}}><h4>{this.state.template_name}</h4></div>
                </div>
                {this.state.documentList.length > 0
                    && (
                        this.state.documentList.map((item, index) => (
                            <div key={index} className="center-block" style={{ pageBreakAfter: 'always' }}>

                                <div style={{ marginBottom: '5px', marginLeft: '5px', color: 'blue', fontSize: '20px' }}>{(index + 1) + ". " + item.document_name}</div>
                                {!item.ispdf ? (<div><ReactQuill
                                    theme={'snow'}
                                    value={item.document_description}
                                    readOnly={true}
                                    modules={{ toolbar: false, }}
                                    style={{ border: '0px', width: '210mm', padding: '10px', color: 'black' }}
                                    className="reactqillParent"
                                /></div>) : (
                                    this.loadPdf(item.pdf_attachment)
                                )}

                            </div>
                        ))
                    )
                }
            </div>
        )
    }

}


export default inject('documentStore')(applicationRouter(withLocalization(withRemoveDialog(observer(DocumentReport)))));